import { Close, KeyboardArrowDown } from '@mui/icons-material';
import { Checkbox, ListItemText, MenuItem, Select } from '@mui/material';
import React, { useEffect, useState } from 'react';
import '../../components/app/common.scss';


function CustomSelect({ value, defaultValue = undefined, name = '', className = '', parent = undefined, prop = undefined,
    renderValue = undefined, onChange, options, multiple = false, outerSelection = false, required = false, closeIcon = undefined,
    renderOptions = (c, i, selected) => <MenuItem key={i} value={c}>
        {multiple ? <><Checkbox checked={selected.indexOf(c) > -1} />
            <ListItemText primary={c} /></>
            : c}
    </MenuItem> }) {
    const [selection, setSelection] = useState([]);
    const [showOptions, setShowOptions] = useState(false);
    const unselect = (i) => {
        selection.splice(i, 1);
        setSelection([...selection]);
    }

    const handleInputChange = (e, onChange) => {
        e.preventDefault();
        if(parent) {
            parent[prop || 'value'] = e.target.value;
        }
        onChange && onChange(e);
    }

    return (
        <div className='custom-select-component'>
            <Select
                id="select-component"
                fullWidth
                value={value}
                open={showOptions}
                native={false}
                onOpen={() => setShowOptions(true)}
                onClose={() => setShowOptions(false)}
                defaultValue={defaultValue}
                multiple={multiple}
                className={className}
                name={name}
                required={required}
                displayEmpty={outerSelection}
                renderValue={(selected) => {
                    selected.constructor === Array && setSelection(selected);
                    return renderValue ? renderValue(selected) : multiple ? selected.join(', ') : selected;

                }}
                IconComponent={() => (<KeyboardArrowDown />)}
                onChange={(e) => handleInputChange(e, onChange)}
                inputProps={{ 'aria-label': 'Without label' }}
            >
                {outerSelection && <Close className='close-btn' onClick = {() => setShowOptions(false)} />}
                {options.map((c, i) => renderOptions(c, i, selection))}
                
            </Select>
            {
                outerSelection && <div className='categories-selected'>
                    {selection?.map((c, i) => <div className='category-selected' key={i}>
                        <span>{c}</span>
                        <div onClick={() => unselect(i)}>{closeIcon ? closeIcon : <Close />}</div>
                    </div>)}
                </div>
            }
        </div>
    );
}

export default CustomSelect;